// Overlay animazione apertura pagina
import trackUserInteraction, { bindTrackingToElements } from "./tracking";
import { lockBodyScroll, unlockBodyScroll } from "./scroll-lock";

import "./main.js";
import "./share.js";
import "../css/sfide-che-uniscono.scss";
import Splide from "@splidejs/splide";

export { trackUserInteraction, bindTrackingToElements };

window.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("page-overlay");
  if (!overlay) return;

  // Se già visto in precedenza, salta animazione e rimuovi overlay
  try {
    if (localStorage.getItem("overlaySeen") === "true") {
      overlay.remove();
      return;
    }
  } catch (e) {}

  // Attiva animazione loghi
  overlay.querySelector(".logo-left").classList.add("logo-left");
  overlay.querySelector(".logo-right").classList.add("logo-right");

  // Variabile di stato per evitare doppio fade out
  let overlayFaded = false;
  let fadeTimeout;
  const MIN_OVERLAY_TIME = 1500; // 1.5 secondi
  let animationStartTime = Date.now();

  // Funzione per animare il buco all'avvio e rimuovere l'overlay
  function startOverlayFadeOut() {
    if (overlayFaded) return;
    overlayFaded = true;
    clearTimeout(fadeTimeout);
    let startTime = null;
    const duration = 1000; // 1 secondo

    function animateHole(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);

      // Curva di easing cubic-bezier(0.77,0,0.175,1)
      const easeProgress =
        progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      const holeSize = easeProgress * 100;

      overlay.style.mask = `radial-gradient(circle at center, transparent ${holeSize}%, #040832 ${holeSize}%)`;
      overlay.style.webkitMask = `radial-gradient(circle at center, transparent ${holeSize}%, #040832 ${holeSize}%)`;

      if (progress < 1) {
        requestAnimationFrame(animateHole);
      } else {
        overlay.classList.add("hide");
        setTimeout(() => {
          try {
            localStorage.setItem("overlaySeen", "true");
          } catch (e) {}
          overlay.remove();
        }, 100);
      }
    }

    requestAnimationFrame(animateHole);
  }

  // Timeout di sicurezza: fade out dopo 5 secondi se la pagina non è ancora caricata
  fadeTimeout = setTimeout(() => {
    startOverlayFadeOut();
  }, 5000);

  // Avvia il fade out dopo il caricamento completo della pagina, ma solo dopo almeno 1.5s dall'inizio animazione
  window.addEventListener("load", () => {
    const elapsed = Date.now() - animationStartTime;
    if (elapsed >= MIN_OVERLAY_TIME) {
      startOverlayFadeOut();
    } else {
      setTimeout(() => {
        startOverlayFadeOut();
      }, MIN_OVERLAY_TIME - elapsed);
    }
  });
});

// Animation for card hover effect
document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".card-hover-expand");

  cards.forEach((card) => {
    card.addEventListener("mouseenter", function () {
      anime({
        targets: this,
        scale: 1.05,
        duration: 300,
        easing: "easeOutQuad",
      });
    });

    card.addEventListener("mouseleave", function () {
      anime({
        targets: this,
        scale: 1,
        duration: 300,
        easing: "easeOutQuad",
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const carouselItems = document.querySelectorAll(".carousel-item-wrapper");
  const athleteContents = document.querySelectorAll(".athlete-content");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");
  let currentIndex = 0;
  let lastActiveIndex = 0;
  let isMobile = window.innerWidth <= 819;
  let touchStartX = 0;
  let touchEndX = 0;

  function handleTouchStart(e) {
    if (!isMobile) return;
    touchStartX = e.changedTouches[0].screenX;
  }

  function handleTouchMove(e) {
    if (!isMobile) return;
    touchEndX = e.changedTouches[0].screenX;
  }

  function handleTouchEnd(e) {
    if (!isMobile) return;
    const minSwipeDistance = 40;
    const deltaX = touchEndX - touchStartX;
    if (Math.abs(deltaX) > minSwipeDistance) {
      if (deltaX < 0) {
        currentIndex = (currentIndex + 1) % carouselItems.length;
        updateCarousel();
      } else {
        currentIndex =
          (currentIndex - 1 + carouselItems.length) % carouselItems.length;
        updateCarousel();
      }
    }
  }

  function addTouchListeners() {
    const carousel = document.querySelector(".carousel-items");
    if (carousel) {
      carousel.addEventListener("touchstart", handleTouchStart, {
        passive: true,
      });
      carousel.addEventListener("touchmove", handleTouchMove, {
        passive: true,
      });
      carousel.addEventListener("touchend", handleTouchEnd, { passive: true });
    }
  }

  function removeTouchListeners() {
    const carousel = document.querySelector(".carousel-items");
    if (carousel) {
      carousel.removeEventListener("touchstart", handleTouchStart);
      carousel.removeEventListener("touchmove", handleTouchMove);
      carousel.removeEventListener("touchend", handleTouchEnd);
    }
  }

  function createPagination() {
    const verticalCarousel = document.querySelector(".protagonisti");
    let paginationContainer = document.querySelector(".carousel-pagination");

    if (!paginationContainer) {
      paginationContainer = document.createElement("div");
      paginationContainer.className = "carousel-pagination";
      verticalCarousel.parentNode.insertBefore(
        paginationContainer,
        verticalCarousel.nextSibling
      );
    }

    paginationContainer.innerHTML = "";

    carouselItems.forEach((_, index) => {
      const dot = document.createElement("div");
      dot.className = "pagination-dot";
      if (index === currentIndex) dot.classList.add("active");

      dot.addEventListener("click", () => {
        currentIndex = index;
        updateCarousel();
      });

      paginationContainer.appendChild(dot);
    });
  }

  function getSlideDirection(from, to) {
    if (from === to) return null;
    const length = carouselItems.length;
    const forwardSteps = (to - from + length) % length;
    const backwardSteps = (from - to + length) % length;

    if (forwardSteps === backwardSteps) {
      return forwardSteps === 0 ? null : "next";
    }

    return forwardSteps < backwardSteps ? "next" : "prev";
  }

  function updateCarousel() {
    const length = carouselItems.length;
    if (!length) return;
    const prevIndex = (currentIndex - 1 + length) % length;
    const nextIndex = (currentIndex + 1) % length;
    const slideDirection = isMobile
      ? getSlideDirection(lastActiveIndex, currentIndex)
      : null;
    const previousActiveIndex = lastActiveIndex;
    const previousPrevIndex = (previousActiveIndex - 1 + length) % length;
    const previousNextIndex = (previousActiveIndex + 1) % length;

    carouselItems.forEach((item) => {
      item.classList.remove("exiting-left", "exiting-right");
    });

    if (isMobile && slideDirection === "next") {
      const candidate = previousPrevIndex;
      if (
        candidate !== currentIndex &&
        candidate !== prevIndex &&
        candidate !== nextIndex
      ) {
        carouselItems[candidate].classList.add("exiting-left");
      }
    } else if (isMobile && slideDirection === "prev") {
      const candidate = previousNextIndex;
      if (
        candidate !== currentIndex &&
        candidate !== prevIndex &&
        candidate !== nextIndex
      ) {
        carouselItems[candidate].classList.add("exiting-right");
      }
    }

    if (isMobile) {
      // Mobile circular carousel logic
      carouselItems.forEach((item, index) => {
        item.classList.remove("active", "prev", "next", "above", "below");
      });

      // Set active item
      carouselItems[currentIndex].classList.add("active");

      // Set previous and next items for circular effect
      carouselItems[prevIndex].classList.add("prev");
      carouselItems[nextIndex].classList.add("next");

      // Update pagination dots
      document.querySelectorAll(".pagination-dot").forEach((dot, index) => {
        dot.classList.toggle("active", index === currentIndex);
      });
    } else {
      // Desktop vertical carousel logic (existing code)
      carouselItems.forEach((item) => {
        item.classList.remove("active", "above", "below");
      });

      carouselItems[currentIndex].classList.add("active");

      const aboveIndex =
        (currentIndex - 1 + carouselItems.length) % carouselItems.length;
      const belowIndex = (currentIndex + 1) % carouselItems.length;

      carouselItems[aboveIndex].classList.add("above");
      carouselItems[belowIndex].classList.add("below");

      carouselItems.forEach((item, index) => {
        if (index === currentIndex) {
          item.style.top = "50%";
          item.style.transform = "translateY(-50%) scale(1)";
          item.style.opacity = "1";
          item.style.filter = "blur(0)";
          item.style.zIndex = "10";
        } else if (item.classList.contains("above")) {
          item.style.top = "20%";
          item.style.transform = "translateY(-50%) scale(0.7)";
          item.style.opacity = "0.5";
          item.style.filter = "blur(1px)";
          item.style.zIndex = "5";
        } else if (item.classList.contains("below")) {
          item.style.top = "80%";
          item.style.transform = "translateY(-50%) scale(0.7)";
          item.style.opacity = "0.5";
          item.style.filter = "blur(1px)";
          item.style.zIndex = "5";
        } else {
          item.style.opacity = "0";
          item.style.zIndex = "1";
        }
      });
    }

    lastActiveIndex = currentIndex;

    // Update content (same for both desktop and mobile)
    athleteContents.forEach((content) => {
      content.classList.add("d-none");
      content.setAttribute("aria-hidden", "true");
      content.setAttribute("tabindex", "-1");
    });

    const targetId = carouselItems[currentIndex].getAttribute("data-target");
    const activeContent = document.getElementById(targetId);
    activeContent.classList.remove("d-none");
    activeContent.setAttribute("aria-hidden", "false");
  }

  function handleResize() {
    const newIsMobile = window.innerWidth <= 819;
    if (newIsMobile !== isMobile) {
      isMobile = newIsMobile;
      if (isMobile) {
        createPagination();
        addTouchListeners();
        // Reset inline styles for mobile
        carouselItems.forEach((item) => {
          item.style.top = "";
          item.style.transform = "";
          item.style.opacity = "";
          item.style.filter = "";
          item.style.zIndex = "";
        });
      } else {
        // Remove pagination on desktop
        const pagination = document.querySelector(".carousel-pagination");
        if (pagination) pagination.remove();
        removeTouchListeners();
        // Remove mobile classes
        carouselItems.forEach((item) => {
          item.classList.remove("prev", "next");
        });
      }
      updateCarousel();
    }
  }

  // Initialize
  if (isMobile) {
    createPagination();
    addTouchListeners();
  }
  updateCarousel();

  // Event listeners for desktop buttons
  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      currentIndex =
        (currentIndex - 1 + carouselItems.length) % carouselItems.length;
      updateCarousel();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      currentIndex = (currentIndex + 1) % carouselItems.length;
      updateCarousel();
    });
  }

  // Click on carousel items
  carouselItems.forEach((item, index) => {
    item.addEventListener("click", function () {
      currentIndex = index;
      updateCarousel();
    });
  });

  // Listen for window resize
  window.addEventListener("resize", handleResize);
});

// sfida scroll animation
document.addEventListener("DOMContentLoaded", function () {
  // Wrap the right column content in a div with the animation class
  const sfidaRightCol = document.getElementById("sfida-right-col");
  if (sfidaRightCol) {
    const rightColContent = sfidaRightCol.innerHTML;
    sfidaRightCol.innerHTML = `<div class="sfida-right-content">${rightColContent}</div>`;
  }

  // Intersection Observer for scroll animation
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
          observer.unobserve(entry.target); // Only animate once
        }
      });
    },
    {
      threshold: 0.4, // Trigger when 40% of the element is visible
    }
  );

  // Observe the sfida right content
  const sfidaContent = document.querySelector(".sfida-right-content");
  if (sfidaContent) {
    observer.observe(sfidaContent);
  }
});

// Approfondimenti cards and mobile carousel
document.addEventListener("DOMContentLoaded", function () {
  const approfondimentiSection = document.querySelector(
    ".approfondimenti-section"
  );
  if (!approfondimentiSection) return;

  const customCards = approfondimentiSection.querySelectorAll(".custom-card");

  const setCardBackground = (element) => {
    const bgImage = element.getAttribute("data-bg");
    if (bgImage) {
      element.style.setProperty("--bg-image", `url('${bgImage}')`);
    }
  };

  customCards.forEach((card) => {
    setCardBackground(card);
    if (card.classList.contains("expanded")) {
      card.setAttribute("aria-expanded", "true");
    }
  });

  const setExpandedCard = (targetCard) => {
    customCards.forEach((otherCard) => {
      otherCard.classList.remove("expanded");
      otherCard.removeAttribute("aria-expanded");
    });
    targetCard.classList.add("expanded");
    targetCard.setAttribute("aria-expanded", "true");
  };

  customCards.forEach((card) => {
    card.addEventListener("mouseenter", () => setExpandedCard(card));
    card.addEventListener("focusin", () => setExpandedCard(card));
  });

  approfondimentiSection
    .querySelectorAll('.card-hover-text[href="#"]')
    .forEach((link) =>
      link.addEventListener("click", (event) => event.preventDefault())
    );

  const splideEl = document.getElementById("mobileCardsSplide");
  if (splideEl && window.innerWidth <= 991) {
    splideEl.querySelectorAll(".splide__slide").forEach((slide) => {
      setCardBackground(slide);
    });

    const splide = new Splide(splideEl, {
      type: "slide",
      perPage: 1,
      gap: "0.75rem",
      pagination: true,
      arrows: false,
      drag: true,
      focus: "center",
      trimSpace: false,
      breakpoints: {
        600: {
          padding: { left: "10px", right: "10px" },
          gap: "0.75rem",
        },
      },
    });

    splide.mount();
  }
});

// Video Overlay functionality
document.addEventListener("DOMContentLoaded", function () {
  const videoOverlay = document.getElementById("videoOverlay");
  const closeOverlayBtn = document.getElementById("closeOverlay");
  const youtubeEmbed = document.getElementById("youtubeEmbed");
  const overlayEpisodeNumber = document.getElementById("overlayEpisodeNumber");
  const overlayEpisodeTitle = document.getElementById("overlayEpisodeTitle");
  const overlayEpisodeDescription = document.getElementById(
    "overlayEpisodeDescription"
  );

  // Episode data
  const episodes = {
    episode1: {
      number: "EPISODIO 1",
      title: "Rinascere: lo sport che trasforma ",
      description:
        "La pattinatrice <b>Francesca Lollobrigida</b> e il tedoforo <b>Francesco Falduti</b>, due strade diverse, unite dalla volontà di raggiungere l’obiettivo",
      youtubeUrl:
        "https://www.youtube.com/embed/d7v6Ht--5Zs?si=Mdh9rGvrQQY0YZ2F",
    },
    episode2: {
      number: "EPISODIO 2",
      title: "Oltre ogni ostacolo",
      description:
        "<b>Valentina Marchei</b> e la tedofora <b>Sara Sow</b> sanno quanto sia facile cadere nello sport. Ma l’importante è la grinta con cui scegli di rialzarti.",
      youtubeUrl: "https://www.youtube.com/embed/txXmCN2Kcc8",
    },
    episode3: {
      number: "EPISODIO 3",
      title: "Maestri di sport e perseveranza",
      description:
        "Da <b>Davide Bendotti</b>, sciatore paralimpico, impariamo che ogni limite è una sfida. Con il tedoforo <b>Giacomo Melani</b> che la passione riaccende i sogni.",
      youtubeUrl:
        "https://www.youtube.com/embed/8BiEj6vQGyw?si=UDIZiHCncUROp-VS",
    },
    episode4: {
      number: "EPISODIO 4",
      title: "Sport e passione come stile di vita",
      description:
        "Agonismo e dedizione, sfide e obiettivi: la campionessa <b>Isolde Kostner</b> e la tedofora <b>Martina Erba</b> si raccontano.",
      youtubeUrl:
        "https://www.youtube.com/embed/vFV6I2_3oWM?si=Cxj_-lcFY3gVIBdl",
    },
    episode5: {
      number: "EPISODIO 5",
      title: "L’importanza del gioco di squadra",
      description:
        "Per la promessa del curling <b>Giulia Zardini Lacedelli</b> la forza nasce dal gruppo. È quello che insegna anche il tedoforo-allenatore <b> Mauro Suardi</b>.",
      youtubeUrl:
        "https://www.youtube.com/embed/JEW1fcTJMcY?si=KFScupFi2sdahdt4",
    },
  };

  // Function to open overlay with specific episode
  function openEpisodeOverlay(episodeKey) {
    const episode = episodes[episodeKey];

    if (!episode) {
      console.error("Episode not found:", episodeKey);
      return;
    }

    // Set overlay content
    overlayEpisodeNumber.textContent = episode.number;
    overlayEpisodeTitle.textContent = episode.title;
    overlayEpisodeDescription.innerHTML = episode.description;

    // Set YouTube embed URL
    youtubeEmbed.src = episode.youtubeUrl;

    // Show overlay
    videoOverlay.classList.add("active");
    lockBodyScroll("video-overlay");
  }

  // Add event listeners to all watch buttons
  document.querySelectorAll(".watch-button").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const buttonId = this.id;
      // Extract episode number from ID (watchEpisode1 -> episode1)
      const episodeKey = buttonId.replace("watch", "").toLowerCase();

      // Open overlay with corresponding episode
      openEpisodeOverlay(episodeKey);
    });
  });

  // Close overlay when clicking the close button
  closeOverlayBtn.addEventListener("click", function () {
    closeVideoOverlay();
  });

  // Close overlay when clicking outside the video container
  videoOverlay.addEventListener("click", function (e) {
    if (e.target === videoOverlay) {
      closeVideoOverlay();
    }
  });

  // Close overlay when pressing Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && videoOverlay.classList.contains("active")) {
      closeVideoOverlay();
    }
  });

  // Function to close the video overlay
  function closeVideoOverlay() {
    videoOverlay.classList.remove("active");

    // Stop YouTube video by clearing the src
    youtubeEmbed.src = "";

    unlockBodyScroll("video-overlay");
  }
});
